import api from './client'

export const informesApi = {
  entregas: (params) => api.get('/informes/entregas', { params }),
  tiemposEntrega: (params) => api.get('/informes/tiempos-entrega', { params }),
}
